import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { ProtocolSectionAnswersBatchHttpRequestModel } from '../protocolSectionAnswersBatch/types';
import {
  broadcastUpdatedProtocolSectionAnswersBatch,
  broadcastUpdatedProtocolSectionAnswersBatchError,
} from 'serviceWorker/broadcasts/protocolAnswer';
import { patchProtocolAnswersApplicability } from 'serviceWorker/db/inspections/inspections';
import { ProtocolSectionAnswersBatchResult } from 'shared/dtos/out/protocolAnswer';
import { scopeOfQueuedRequest } from 'serviceWorker/helpers/dataScope';

export async function broadcastProtocolSectionAnswersBatchResponse(
  request: HttpRequestEntity,
  response: ProtocolSectionAnswersBatchResult | { error: unknown }
): Promise<void> {
  const putRequest = request as ProtocolSectionAnswersBatchHttpRequestModel;

  if (request.method !== 'PUT') {
    return broadcastUpdatedProtocolSectionAnswersBatchError(
      new Error(
        `${request.method} method not supported for protocolSectionAnswersBatch`
      ),
      putRequest.data?.uniqueId
    );
  }

  if ('error' in response && response.error) {
    return broadcastUpdatedProtocolSectionAnswersBatchError(
      response.error,
      putRequest.data.uniqueId
    );
  }

  const result =
    'isApplicable' in response
      ? response
      : {
          inspectionId: putRequest.data.inspectionId,
          sectionId: putRequest.data.sectionId,
          isApplicable: putRequest.data.protocolSectionAnswersBatchOutDto.isApplicable,
          protocolItemIds: putRequest.data.protocolItemIds,
        };

  await scopeOfQueuedRequest(request).write(() =>
    patchProtocolAnswersApplicability({
      inspectionId: putRequest.data.inspectionId,
      protocolItemIds: putRequest.data.protocolItemIds,
      isApplicable: putRequest.data.protocolSectionAnswersBatchOutDto.isApplicable,
    })
  );

  return broadcastUpdatedProtocolSectionAnswersBatch(
    result,
    putRequest.data.uniqueId
  );
}
